export default class ProjectDataSource {
    static MANUAL = 'MANUAL';
    static MUNISENSE = 'MUNISENSE';
}
